import { Icon } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import { changeVariantRefPath } from "shared/utils/paths"

import { StyledDropdown, Variant, Variants } from "./Styles"

interface DropdownProps {
  onClose: () => void
}

const Dropdown = ({ onClose }: DropdownProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { catalog } = useEditor()
  const { variantRef } = useCatalogNavigation()

  return (
    <StyledDropdown>
      <Variants>
        {[{ ref: null, name: null }, ...catalog.data.variants].map(({ ref, name }) => (
          <Variant
            key={ref}
            onClick={() => {
              navigate(changeVariantRefPath(ref))
              onClose()
            }}
            isSelected={ref === variantRef}
          >
            {name !== null ? (
              <>
                <Icon code="layers" />
                {name}
              </>
            ) : (
              t("variants.select.default")
            )}
          </Variant>
        ))}
      </Variants>
    </StyledDropdown>
  )
}

export default Dropdown
